import { FormattedMessage } from 'react-intl';
import { useLocation } from '../../../context/LocationContext';
import { useOriginalTotalPrice, useTotalPrice } from '../../../hooks/useTotalPrice';
import { useActiveDigitalBill } from '../../../context/DigitalBillStore';

const TotalPrice = () => {
  const { formatCurrency } = useLocation();
  const activeDigitalBill = useActiveDigitalBill();

  const totalPrice = useTotalPrice();
  const originalPrice = useOriginalTotalPrice();

  // Regular price display
  if (totalPrice - originalPrice === 0 || activeDigitalBill !== undefined) {
    return (
      <div className="m-3 flex justify-between mt-2 text-bold">
        <div>
          <FormattedMessage id="generic.total" />:
        </div>
        <div data-cy="total-price">{formatCurrency(totalPrice)}</div>
      </div>
    );
  }
  // Discounted price display
  return (
    <div className="m-3 flex mt-2 justify-between" data-cy="ok">
      <div className="text-bold">
        <FormattedMessage id="generic.total" />:
      </div>
      <div className="flex gap-2 items-center">
        <div className="text-xs line-through text-grey-dark" data-cy="total-price">
          {formatCurrency(originalPrice)}
        </div>
        <div className="text-sm text-bold" data-cy="total-price-discounted">
          {formatCurrency(totalPrice)}
        </div>
      </div>
    </div>
  );
};

export default TotalPrice;
